import { Routes, Route } from "react-router-dom";
import { ConfigTax } from "./list";
import { CreateNcm } from "./create";
import { EditNcm } from "./edit";

export default function ConfigTaxRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ConfigTax />} />
      <Route path="/criar-ncm" element={<CreateNcm />} />
      <Route path="/editar-ncm/:id_ncm" element={<EditNcm />} />
    </Routes>
  );
}
